<template>
  <div class="width-100" style="margin-top: 12px; margin-bottom: 12px;">
    <collapse>
      <collapse-item title="Project Address" name="address">
        <template slot="title">
          <div class="collapse-item-header" style="width: 100%">
            Project Address
          </div>
          <div class="pull-right chat-icon" title="Display Location Map">
            <i class="fa fa-map-o fa-lg" @click="launchMap" v-if="hasLatLng"></i>
          </div>
        </template>
        <div class="project-address bg-white">
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>City</label>
                  <el-autocomplete
                    style="width:100%"
                    class="inline-input"
                    name="city"
                    ref="city"
                    clearable
                    :debounce="150"
                    :disabled="!canEdit"
                    v-model="localCity"
                    :fetch-suggestions="findCities"
                    :trigger-on-focus="false"
                    value-key="name"
                    placeholder="City"
                    @blur="verifyCityAutocompleteSelected"
                    @select="setCityLoadCountiesZips">
                  </el-autocomplete>
                  <small class="text-danger" v-show="errors.has('city')">
                    {{ getError('city') }}
                  </small>
                  <small class="text-danger" v-show="showInvalidAutocompleteWarning('city')">
                    {{ fieldNotValidError('City') }}
                  </small>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>County</label>
                  <el-select class="select"
                             name="county"
                             size="large"
                             clearable
                             :disabled="!canEdit"
                             placeholder="County"
                             @focus="verifyCitySelected"
                             v-validate="modelValidations.county"
                             v-model="address.county">
                    <el-option v-for="option in counties"
                               class="select"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                  <small class="text-danger" v-show="errors.has('county')">
                    {{ getError('county') }}
                  </small>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>State</label>
                  <el-select class="select"
                             name="state"
                             size="large"
                             placeholder=""
                             clearable
                             :disabled="!canEdit"
                             v-validate="modelValidations.state"
                             v-model="address.state">
                    <el-option v-for="option in states"
                               class="select"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                  <small class="text-danger" v-show="errors.has('state')">
                    {{ getError('state') }}
                  </small>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>ZIP</label>
                  <el-select class="select"
                             name="zip"
                             size="large"
                             clearable
                             :disabled="!canEdit"
                             placeholder="Zip"
                             @focus="verifyCitySelected"
                             v-validate="modelValidations.zip"
                             v-model="address.zip">
                    <el-option v-for="option in zipCodes"
                               class="select"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                  <small class="text-danger" v-show="errors.has('zip')">
                    {{ getError('zip') }}
                  </small>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Jurisdiction</label>
                  <el-select class="select"
                             name="jurisdiction"
                             size="large"
                             clearable
                             :disabled="!canEdit"
                             placeholder="Jurisdiction"
                             v-validate="modelValidations.jurisdiction"
                             v-model="address.jurisdiction">
                    <el-option v-for="option in constants.JURISDICTIONS"
                               class="select"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                  <small class="text-danger" v-show="errors.has('jurisdiction')">
                    {{ getError('jurisdiction') }}
                  </small>
                </div>
              </div>
            </div><!-- row -->
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>Street Number</label>
                  <el-input type="text"
                            name="streetNumber"
                            placeholder="Street Number"
                            clearable
                            :disabled="!canEdit"
                            data-vv-name="street number"
                            v-validate="modelValidations.streetNumber"
                            v-model="address.streetNumber" />
                  <small class="text-danger" v-show="errors.has('streetNumber')">
                    {{ getError('streetNumber') }}
                  </small>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Street Name</label>
                  <el-autocomplete
                    style="width:100%"
                    name="streetName"
                    ref="streetName"
                    class="inline-input"
                    clearable
                    :debounce="150"
                    :disabled="!canEdit"
                    data-vv-name="street name"
                    v-model="localStreetName"
                    v-validate="modelValidations.streetName"
                    :fetch-suggestions="findStreets"
                    :trigger-on-focus="false"
                    value-key="name"
                    placeholder="Street Name"
                    @focus="verifyCitySelected"
                    @blur="verifyStreetNameAutocompleteSelected"
                    @select="setStreet">
                  </el-autocomplete>
                  <small class="text-danger" v-show="errors.has('streetName')">
                    {{ getError('streetName') }}
                  </small>
                  <small class="text-danger" v-show="showInvalidAutocompleteWarning('streetName')">
                    {{ fieldNotValidError('Street Name') }}
                  </small>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Building Number</label>
                  <el-input type="text"
                            name="buildingNumber"
                            clearable
                            :disabled="!canEdit"
                            data-vv-name="builder number"
                            placeholder="Building Number"
                            v-validate="modelValidations.buildingNumber"
                            v-model="address.buildingNumber" />
                  <small class="text-danger" v-show="errors.has('buildingNumber')">
                    {{ getError('buildingNumber') }}
                  </small>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Floor Number</label>
                  <el-input type="text"
                            name="floorNumber"
                            placeholder="Floor Number"
                            clearable
                            :disabled="!canEdit"
                            data-vv-name="floor number"
                            v-validate="modelValidations.floorNumber"
                            v-model="address.floorNumber" />
                  <small class="text-danger" v-show="errors.has('floorNumber')">
                    {{ getError('floorNumber') }}
                  </small>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Suite Number</label>
                  <el-input type="text"
                            name="suiteNumber"
                            placeholder="Suite Number"
                            data-vv-name="suite number"
                            clearable
                            :disabled="!canEdit"
                            v-validate="modelValidations.suiteNumber"
                            v-model="address.suiteNumber" />
                  <small class="text-danger" v-show="errors.has('suiteNumber')">
                    {{ getError('suiteNumber') }}
                  </small>
                </div>
              </div>
            </div><!-- row -->
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>Lot No.</label>
                  <el-input type="text"
                            name="lotNumber"
                            placeholder="Lot Number"
                            data-vv-name="lot number"
                            clearable
                            :disabled="!canEdit"
                            v-validate="modelValidations.lotNumber"
                            v-model="address.lotNumber" />
                  <small class="text-danger" v-show="errors.has('lotNumber')">
                    {{ getError('lotNumber') }}
                  </small>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Block No.</label>
                  <el-input type="text"
                            name="blockNumber"
                            placeholder="Block Number"
                            clearable
                            :disabled="!canEdit"
                            data-vv-name="block number"
                            v-validate="modelValidations.blockNumber"
                            v-model="address.blockNumber" />
                  <small class="text-danger" v-show="errors.has('blockNumber')">
                    {{ getError('blockNumber') }}
                  </small>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Phase</label>
                  <el-input type="text"
                            name="phase"
                            placeholder="Phase"
                            clearable
                            :disabled="!canEdit"
                            v-validate="modelValidations.phase"
                            v-model="address.phase" />
                  <small class="text-danger" v-show="errors.has('phase')">
                    {{ getError('phase') }}
                  </small>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Section</label>
                  <el-input type="text"
                            name="section"
                            placeholder="Section"
                            clearable
                            :disabled="!canEdit"
                            v-validate="modelValidations.section"
                            v-model="address.section" />
                  <small class="text-danger" v-show="errors.has('section')">
                    {{ getError('section') }}
                  </small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>Latitude</label>
                  <el-input type="text"
                            name="latitude"
                            placeholder="Latitude"
                            data-vv-name="latitude"
                            clearable
                            :disabled="!canEdit"
                            v-validate="modelValidations.latitude"
                            v-model="address.lat" />
                </div>
                <small class="text-danger" v-show="address.usingLatLngOfCity">
                  Lat/Lng are set to City centre. Check Street Name/Num and Save to try to update.
                </small>
                <small class="text-danger" v-show="!address.lat || !address.lng">
                  Save project address to fetch lat/lng.
                </small>
                <small class="text-danger" v-show="errors.has('latitude')">
                  {{ getError('latitude') }}
                </small>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Longitude</label>
                  <el-input type="text"
                            name="longitude"
                            placeholder="Longitude"
                            data-vv-name="longitude"
                            clearable
                            :disabled="!canEdit"
                            v-validate="modelValidations.longitude"
                            v-model="address.lng" />
                </div>
                <small class="text-danger" v-show="errors.has('longitude')">
                  {{ getError('longitude') }}
                </small>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Legal Description</label>
                  <el-input type="text"
                            name="legalDescription"
                            placeholder="Legal Description"
                            data-vv-name="legal description"
                            clearable
                            :disabled="!canEdit"
                            v-validate="modelValidations.legalDescription"
                            v-model="address.legalDescription" />
                  <small class="text-danger" v-show="errors.has('legalDescription')">
                    {{ getError('legalDescription') }}
                  </small>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Legal Subdivision</label>
                  <el-autocomplete
                    style="width:100%"
                    name="legalSubdivision"
                    ref="legalSubdivisionId"
                    class="inline-input"
                    clearable
                    :debounce="150"
                    :disabled="!canEdit"
                    data-vv-name="legal subdivision"
                    v-model="localLegalSubdivisionName"
                    v-validate="modelValidations.legalSubdivisionId"
                    :fetch-suggestions="findLegalSubdivisions"
                    :trigger-on-focus="false"
                    value-key="name"
                    placeholder="Legal Subdivision"
                    @blur="verifyLegalSubdivisionAutocompleteSelected"
                    @select="setLegalSubdivision">
                  </el-autocomplete>
                  <small class="text-danger" v-show="errors.has('legalSubdivisionId')">
                    {{ getError('legalSubdivisionId') }}
                  </small>
                  <small class="text-danger" v-show="showInvalidAutocompleteWarning('legalSubdivisionId')">
                    {{ fieldNotValidError('Legal Subdivision') }}
                  </small>
                </div>
              </div>
            </div>
            <div class="row" v-if="canEdit">
              <div class="col-md-12">
                <button type="submit" @click="validateAndSubmit" class="btn btn-fill btn-info btn-wd pull-right" :disabled="isProcessing">Save</button>
              </div>
            </div>
          </div><!-- card content -->
        </div>
      </collapse-item>
    </collapse>
  </div>
</template>
<script>
import {Select, Option, Tag, Autocomplete} from 'element-ui'
import {mapFields} from 'vee-validate'
import _ from 'lodash'
import {mapGetters} from 'vuex'
import {
  notifySuccess,
  notifyError,
  kvpsForSelectFromArray,
  findCities,
  findStreets,
  setCityLoadCountiesZips,
  findLegalSubdivisions,
  verifyAutocompleteSelected,
  autocompleteTextButNoValueMessage,
  autocompleteTextButNoValue
} from 'src/utilities/utils'
import {Collapse, CollapseItem} from 'element-ui'
import Constants from 'src/utilities/constants'
import {OK} from 'http-status-codes'
import {sync} from 'vuex-pathify'

export default {
  components: {
    [Autocomplete.name]: Autocomplete,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tag.name]: Tag,
    Collapse,
    CollapseItem
  },
  props: ['id'],
  computed: {
    ...mapFields([
      'city',
      'county',
      'state',
      'zip',
      'jurisdiction',
      'streetNumber',
      'suiteNumber',
      'buildingNumber',
      'floorNumber',
      'streetName',
      'lotNumber',
      'blockNumber',
      'legalSubdivisionId',
      'phase',
      'section',
      'latitude',
      'longitude']
    ),
    ...mapGetters({
      states: 'states',
      cities: 'address/cities',
      activeModals: 'modalTracker/activeModals'
    }),
    address: sync('projects/edit/address'),
    isProcessing() {
      return this.$store.get('processing')
    },
    canEdit() {
      const jobs = this.$store.get('jobs/projectJobs')
      if (this.$store.get('security/isInGroup', Constants.GROUPS.ADVANCED_USERS)
        || this.$store.get('security/isInGroup', Constants.GROUPS.STANDARD_USERS)
        || this.$store.get('security/isInGroup', Constants.GROUPS.POWER_USERS)) {

        // If Job >1 in Project, or if there is one Job only and Completed, restrict changing the Project Address to Admin and Super Users only.
        if ((jobs.length === 1 && jobs[0].status === Constants.STATUSES.COMPLETED) || jobs.length > 1) {
          return false
        }
      }
      // all admin and super users can edit OR no jobs have been completed in this project
      return true
    },
    hasLatLng() {
      const lat = this.$store.get('projects/edit/address@lat')
      const lng = this.$store.get('projects/edit/address@lng')
      return !_.isEmpty(lat) && !_.isEmpty(lng)
    }
  },
  data () {
    return {
      constants: Constants,
      initialState: {
        address: null
      },
      counties: [],
      zipCodes: [],
      localCity: null,
      localStreetName: null,
      localLegalSubdivisionName: null,
      modelValidations: {
        city: {},
        county: {},
        state: {},
        zip: {
          digits: 5
        },
        jurisdiction: {},
        streetNumber: {},
        suiteNumber: {},
        buildingNumber: {},
        floorNumber: {},
        streetName: {},
        lotNumber: {},
        blockNumber: {},
        legalSubdivisionId: {},
        phase: {},
        section: {},
        latitude: {decimal: true},
        longitude: {decimal: true}
      }
    }
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    showInvalidAutocompleteWarning(refAndPathName) {
      // $ref has to match prop in store
      return autocompleteTextButNoValue(this, refAndPathName, this.$store.get(`projects/edit/address@${refAndPathName}`))
    },
    fieldNotValidError(field) {
      return autocompleteTextButNoValueMessage(field)
    },
    async validateAndSubmit() {
      if (await this.$validator.validateAll()) {
        await this.patch()
      }
    },
    async patch() {
      const response = await this.$store.dispatch('mergePatch', this.patchPayload())
      if (response.result === Constants.RETURN_CODES.SUCCESS) {
        this.$store.set('projects/edit/address/all', response.data.address)
        notifySuccess(this, 'Project Address Updated Successfully')
      } else {
        notifyError(this, 'Failed to Update Project Address')
      }
    },
    patchPayload() {
      return {
        id: this.id,
        endpoint: 'projects',
        data: {
          address: this.$store.get('projects/edit/address/all')
        }
      }
    },
    async setInitialState(address) {
      if (address.legalSubdivisionId) {
        const responseLegalSubdivision = await this.$store.dispatch('fetchById',
          {
            endpoint: 'legal-subdivisions',
            id: address.legalSubdivisionId
          })

        if (OK === responseLegalSubdivision.status) {
          this.localLegalSubdivisionName = responseLegalSubdivision.data.name
        }
      }

      // get the complete city object with counties and zip codes for the currently selected city
      if (address.city) {
        this.localCity = address.city

        const responseCity = await this.$store.dispatch('projects/edit/address/fetchCityByCityName', address.city)

        if (OK === responseCity.status) {
          this.counties = kvpsForSelectFromArray(responseCity.data.counties)
          this.zipCodes = kvpsForSelectFromArray(responseCity.data.zipCodes)
        }
      }

      if (address.streetName) {
        this.localStreetName = address.streetName
      }
    },
    verifyCitySelected() {
      if (!this.$store.get('projects/edit/address/city' || !this.localCity)) {
        this.$eventHub.$emit('show-modal-6', 'No City Error', null, '500px')
      }
    },
    async findLegalSubdivisions(text, cb) {
      findLegalSubdivisions(this, text, cb, 'projects/edit/address/')
    },
    setLegalSubdivision(legalSubdivision) {
      this.localLegalSubdivisionName = legalSubdivision.name
      this.$store.set('projects/edit/address/legalSubdivisionId', legalSubdivision.id)
    },
    clearLegalSubdivision() {
      this.localLegalSubdivisionName = null
    },
    verifyLegalSubdivisionAutocompleteSelected () {
      verifyAutocompleteSelected(this, 'projects/edit/address/legalSubdivisionId', 'legal subdivision', this.localLegalSubdivisionName)
    },
    async findCities(text, cb) {
      findCities(this, text, cb, 'projects/edit/address/city')
    },
    setCityLoadCountiesZips(city) {
      setCityLoadCountiesZips(this, city, 'projects/edit/address/city')
    },
    verifyCityAutocompleteSelected() {
      if (this.localCity !== this.$store.get('projects/edit/address/city')) {
        verifyAutocompleteSelected(this, 'projects/edit/address/city', 'city', this.localCity)
        this.resetDependentAutocompleteFields()
      }
    },
    clearCity() {
      this.localCity = null
    },
    async findStreets(text, cb) {
      await findStreets(this, text, cb, 'projects/edit/address/')
    },
    launchMap() {
      const address = this.$store.get('projects/edit/address/all')
      this.$eventHub.$emit('show-modal-1', 'Address Map', address, '90%')
    },
    resetDependentAutocompleteFields() {
      this.counties = []
      this.zipCodes = []
      this.localStreetName = null
      this.$store.set('address/cities', [])
      this.$store.set('projects/edit/address/city', null)
      this.$store.set('projects/edit/address/county', null)
      this.$store.set('projects/edit/address/zip', null)
    },
    setStreet(street) {
      if (street) {
        this.localStreetName = street.name
        this.$store.set('projects/edit/address/streetName', street.name)
      }
    },
    clearStreet() {
      this.localStreetName = null
    },
    verifyStreetNameAutocompleteSelected() {
      verifyAutocompleteSelected(this, 'projects/edit/address/streetName', 'street name', this.localStreetName)
    },
  },
  mounted() {
    this.$eventHub.$on('citySaved', this.setCityLoadCountiesZips)
    this.$eventHub.$on('noCitySaved', this.clearCity)
    this.$eventHub.$on('legalSubdivisionSaved', this.setLegalSubdivision)
    this.$eventHub.$on('noLegalSubdivisionSaved', this.clearLegalSubdivision)
    this.$eventHub.$on('streetSaved', this.setStreet)
    this.$eventHub.$on('noStreetSaved', this.clearStreet)
    this.$eventHub.$on('projectAddressLoaded', this.setInitialState)
    this.$store.set('address/cities', [])
    this.$store.set('address/streets', [])

    // Depending on how the page loads, sometimes the eventHub call above doesn't work reliably.
    // Same for the code below. The two approaches together seem to cover both new page loads and loading from search
    // results screen.
    if (!this.initialState.address) {
      this.setInitialState(this.$store.get('projects/edit/address/all'))
    }
  },
  destroyed() {
    this.$eventHub.$off('citySaved')
    this.$eventHub.$off('noCitySaved')
    this.$eventHub.$off('legalSubdivisionSaved')
    this.$eventHub.$off('noLegalSubdivisionSaved')
    this.$eventHub.$off('streetSaved')
    this.$eventHub.$off('noStreetSaved')
    this.$eventHub.$off('projectAddressLoaded')
  },
  watch: {
    localCity: {
      handler: function(city) {
        if (!city) {
          this.resetDependentAutocompleteFields()
        }
      }
    },
    localStreetName: {
      handler: function(streetName) {
        if (!streetName) {
          this.$store.set('projects/edit/address/streetName', null)
        }
      }
    },
    localLegalSubdivisionName: {
      handler: function(localLegalSubdivisionName) {
        if (!localLegalSubdivisionName) {
          this.$store.set('projects/edit/address/legalSubdivisionId', null)
        }
      }
    }
  }
}
</script>
<style scoped>

</style>
